import { render, staticRenderFns } from "./DataList.vue?vue&type=template&id=71d71444&scoped=true"
import script from "./DataList.vue?vue&type=script&lang=js"
export * from "./DataList.vue?vue&type=script&lang=js"
import style0 from "./DataList.vue?vue&type=style&index=0&id=71d71444&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d71444",
  null
  
)

export default component.exports